import BaseWidget, { escapeHtml } from './baseWidget.js';
import stammdatenService from '../../services/stammdatenService.js';
import { getAktuellerZeitraum } from '../../util.js';

/**
 * Listet alle Mitarbeiter mit ungelesenen Nachrichten im Postfach auf.
 * Klick auf einen Namen öffnet den Mitarbeiter im Postfach-Reiter.
 */
export default class NewMessagesWidget extends BaseWidget {
	async onRender() {
		this.setLoading();
		const zeitraum = getAktuellerZeitraum();
		const malist = await stammdatenService.holeMitarbeiterListe(
			stammdatenService.aktuelleBetriebsstaette,
			zeitraum,
		);

		const ungelesen = malist
			.filter((ma) => ma.NeueMitteilung && !ma.Archiviert)
			.sort((a, b) => `${a.Nachname}, ${a.Vorname}`.localeCompare(`${b.Nachname}, ${b.Vorname}`, 'de'));

		// Header-Badge mit Anzahl ungelesener Nachrichten synchron halten.
		// Wird sonst nur beim Rendern der Mitarbeiterliste (erstelleMitarbeiterListe) aktualisiert.
		const inboxBadge = document.getElementById('ma-nachrichten-count');
		if (inboxBadge) {
			if (ungelesen.length > 0) {
				inboxBadge.innerText = ungelesen.length;
				inboxBadge.style.display = 'inline-flex';
			} else {
				inboxBadge.style.display = 'none';
			}
		}

		if (ungelesen.length === 0) {
			this.setEmpty('Keine ungelesenen Nachrichten.');
			return;
		}

		this.bodyEl.innerHTML = `
			<div class="widget-messages-count">
				<i class="bi bi-envelope-fill"></i>
				<span>${ungelesen.length} Mitarbeiter mit ungelesenen Nachrichten</span>
			</div>
			<div class="widget-messages-list"></div>
		`;
		const listEl = this.bodyEl.querySelector('.widget-messages-list');
		ungelesen.forEach((ma) => {
			const item = document.createElement('div');
			item.className = 'widget-messages-item';
			item.innerHTML = `<i class="bi bi-person-fill"></i> ${escapeHtml(`${ma.Nachname}, ${ma.Vorname}`)}`;
			item.addEventListener('click', async () => {
				await window.myHandlers.selectMA(ma._id, 'Postfach');
				await window.myHandlers.openNachrichten();
			});
			listEl.appendChild(item);
		});
	}
}
